import { extend } from 'umi-request';
import { getI18nCurrentLocale } from './i18n';
import getSsoGrayTag from './getSsoGrayTag';

/**
 * http状态码
 */
const codeMessage: any = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};

/**
 * 异常处理程序
 * @param error
 */
const errorHandler = (error: any) => {
  const { response } = error;

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status, url } = response;
    console.log({
      message: `请求错误 ${status}: ${url}`,
      description: errorText
    });
    response.code = status;
    return response;
  }
  return response;
};

// 扩展请求
const umiRequest = extend({
  customRequest: 'request1', // request拦截器, 改变url 或 options, 和跨域的拦截器是共享的,都会走到
  errorHandler,
  // 默认错误处理
  credentials: 'include' // 默认请求是否带上cookie
});


umiRequest.interceptors.request.use((url, options = {}) => {
  const clientId = getSsoGrayTag();
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    locale: getI18nCurrentLocale(),
    // 请求中header带上clientid, 跳转链接带上client_id或clientId或clientid, 用于sso灰度.
    ssoGrayTag: clientId
  };
  let newOptions = options;
  if (options && options.customRequest === 'request1') {
    newOptions = { ...options, headers };
  }
  return {
    url,
    options: newOptions
  };
});

/**
 * @description: 自定义参数, 方便以后扩展
 * @return {*}
 */
interface IOptions {
  timeout?: number; // 超时时间
}
/**
 * 数据请求
 * @param Object Irequest
 */
const request = (url: string, method: string, params: any, prefix: string, options?: IOptions): Promise<any> => {
  return new Promise((resolve, reject) => {
    const requestUrl = prefix ? `${prefix}${url}` : url;
    umiRequest(requestUrl, {
      method,
      ...params,
      ...(options || {})
    })
      .then((response: any) => {
        if (response && response.code === 200) {
          resolve(response.data);
        } else if (response && response.code === 1000200) {
          const { ctxId, action } = response || {};
          if (ctxId && action) {
            action.ctxId = ctxId;
          }
          resolve(action);
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            ...(response || {}),
            code: response?.code,
            message: response?.msg || response?.message
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const pureRequest = (url: string, method: string, params: any, prefix: string, options?: IOptions): Promise<any> => {
  return new Promise((resolve, reject) => {
    const requestUrl = prefix ? `${prefix}${url}` : url;
    umiRequest(requestUrl, {
      method,
      ...params,
      ...(options || {})
    })
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  get: (url: string, params?: any, prefix?: string, options?: IOptions) => request(url, 'GET', { params }, prefix, options),
  post: (url: string, params?: any, prefix?: string, options?: IOptions) => request(url, 'POST', { data: params }, prefix, options)
};
